import axiosInstance from '@/api/axios'

// 修改手机号 旧手机获取短信验证码 新手机号获取短信验证码
export function sendSMSMessage(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/auth/sendSMSMessage',
        method: 'post',
        data: parameter,
    })
}
// 修改手机号 下一步校验手机号
export function validPhoneNumCode(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/auth/validPhoneNumCode',
        method: 'post',
        data: parameter,
    })
}
// 修改手机号 新手机和验证码发送修改
export function modifyPhoneNum(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/auth/modifyPhoneNum',
        method: 'post',
        data: parameter,
    })
}
